var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4001 13.0001C23.4001 18.7439 18.7439 23.4001 13.0001 23.4001C7.25634 23.4001 2.6001 18.7439 2.6001 13.0001C2.6001 7.25634 7.25634 2.6001 13.0001 2.6001C18.7439 2.6001 23.4001 7.25634 23.4001 13.0001ZM14.3001 18.2001C14.3001 18.9181 13.7181 19.5001 13.0001 19.5001C12.2821 19.5001 11.7001 18.9181 11.7001 18.2001C11.7001 17.4821 12.2821 16.9001 13.0001 16.9001C13.7181 16.9001 14.3001 17.4821 14.3001 18.2001ZM13.0001 6.5001C12.2821 6.5001 11.7001 7.08213 11.7001 7.8001V13.0001C11.7001 13.7181 12.2821 14.3001 13.0001 14.3001C13.7181 14.3001 14.3001 13.7181 14.3001 13.0001V7.8001C14.3001 7.08213 13.7181 6.5001 13.0001 6.5001Z",
    fill: "#CD4141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToastIcon);
export default __webpack_public_path__ + "static/media/ErrorToastIcon.9c1661e3184c3226138446511464fe7f.svg";
export { ForwardRef as ReactComponent };